import React, { useState, useContext } from 'react';
import noteContext from './Context/NoteContext';
import Categories from './Categories';
import EditForm from './EditForm/EditForm';
import InputForm from './InputForm';
import Modal from './Modal/Modal';

// export default function ModalShow(){
//     const {
//         modalType, setModalType,
//     } = useContext(noteContext);

//     return(

//             <div className="temp div">
//                 {<Modal>
//                     {modalType === "addValue" && <InputForm />}
//                     {modalType === "Edit" && <EditForm />}
//                     {modalType === "category" && <Categories />}
//                     {modalType === "editCategory" && <Categories />}
//                 </Modal>}
//             </div>
//     )
// }



export default function ModalShow() {
    const { modalType } = useContext(noteContext);

    return (
        <div className="temp div">
            <Modal>
                {/* --- ADD VALUE SECTION --- */}
                {(modalType === "addValue" || modalType === "category") && (
                    <div style={{ display: 'contents' }}>
                        {/* Hidden but alive */}
                        <div style={{ display: modalType === "category" ? "none" : "block" }}>
                            <InputForm />
                        </div>
                        {/* The overlay layer */}
                        {modalType === "category" && <Categories />}
                    </div>
                )}

                {/* --- EDIT SECTION --- */}
                {(modalType === "Edit" || modalType === "editCategory") && (
                    <div style={{ display: 'contents' }}>
                        {/* Hidden but alive */}
                        <div style={{ display: modalType === "editCategory" ? "none" : "block" }}>
                            <EditForm />
                        </div>
                        {/* The overlay layer */}
                        {modalType === "editCategory" && <Categories />}
                    </div>
                )}
            </Modal>
        </div>
    )
}